/* Modifier un parcours en service — RJ-08 (Bible §27).
   A live edit creates a new Journey version and the merchant chooses how
   people in progress are mapped onto it. Silent remapping does not exist,
   and gifts already issued stay pinned to the version that issued them. */
import { useState } from 'react'
import { Button, ErrorState, ListRow, Note } from '@/ui'
import { useMigration } from './api'
import { Chargement, Retour } from './parts'

const CHOIX = [
  { id: 'compatible', label: 'Continuer sur l’étape compatible', meta: 'recommandé — chacun reste où il est' },
  { id: 'garder', label: 'Garder v2 jusqu’à la prochaine émission', meta: '' },
  { id: 'redemarrer', label: 'Redémarrer avec information client', meta: '' },
]

export default function Migration() {
  const { data, isPending, isError, refetch } = useMigration()
  const [choix, setChoix] = useState('compatible')

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger la migration."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 720 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Modifier un parcours en service</h2>

      <p className="t-body">
        {data.inProgress} clients ont une progression en cours. Comment appliquer
        la {data.newVersion}&nbsp;?
      </p>

      <section>
        {CHOIX.map(c => (
          <ListRow key={c.id} title={c.label} meta={c.meta || undefined}
            end={<input type="radio" name="migration" className="chk" style={{ borderRadius: '50%' }}
              checked={choix === c.id} onChange={() => setChoix(c.id)} aria-label={c.label} />} />
        ))}
      </section>

      <Note tone="candour">
        Le remappage silencieux n’existe pas. Les cadeaux émis restent épinglés à leur version.
      </Note>
    </div>
  )
}
